import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Button } from 'react-bootstrap';

const ProductBanner = ({
  heading1 = 'Comprehensive Automation Solutions for Every Need',
  content1 = 'Explore our range of robotic and mechanized systems designed to enhance productivity and efficiency.',
  action1 = 'Reach out now!',
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        padding: '2rem 0',
        textAlign: 'center',
      }}
    >
      <Container>
        <Row>
          <Col>
            <h1
              style={{
                fontSize: '2.5rem',
                fontWeight: 'bold',
                marginBottom: '1rem',
              }}
            >
              {heading1}
            </h1>
            <p
              style={{
                fontSize: '1.25rem',
                marginBottom: '2rem',
              }}
            >
              {content1}
            </p>
            <Button
              href="/contact-us"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              style={{
                backgroundColor: '#d53636',
                borderColor: '#d53636',
                padding: '0.75rem 1.5rem',
                fontSize: '1rem',
                borderRadius: '0.375rem',
                transform: isHovered ? 'scale(1.1)' : 'scale(1)', // Scale effect
                transition: 'transform 0.2s ease-in-out', // Smooth transition
              }}
              className="text-white"
            >
              {action1}
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

ProductBanner.propTypes = {
  heading1: PropTypes.string,
  content1: PropTypes.string,
  action1: PropTypes.string,
};

export default ProductBanner;
